var _defs, _path, _path2, _defs2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "blur"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 15H10M13 15H18M5 20H10M13 20H18M1 22V22C1 23.1046 1.89543 24 3 24H20C21.1046 24 22 23.1046 22 22V3C22 1.89543 21.1046 1 20 1H3C1.89543 1 1 1.89497 1 2.99954C1 9.77894 0.999998 20.1899 1 22Z",
    stroke: "url(#paint0_linear_26_24)",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 6C4 4.89543 4.89543 4 6 4H17C18.1046 4 19 4.89543 19 6V9C19 10.1046 18.1046 11 17 11H6C4.89543 11 4 10.1046 4 9V6Z",
    fill: "url(#paint1_linear_26_24)"
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26_24",
    x1: 1,
    y1: 13.2667,
    x2: 22,
    y2: 13.2667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E85EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DD9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26_24",
    x1: 4,
    y1: 7.73334,
    x2: 19,
    y2: 7.73334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E85EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DD9FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsActive);
export default __webpack_public_path__ + "static/media/news-active.cebbed2304c53eb3902273659d9311d0.svg";
export { ForwardRef as ReactComponent };